import {
  ILayout,
  ILocationGroupTabList,
  IScreenOrientation,
} from 'src/interfaces';

export const getAdditionalLocationGroupFilters = (
  layout: ILayout,
  orientation?: IScreenOrientation,
  selectedLocationGroupId?: string | number,
  daypartId?: number,
) => {
  return `&layout_type_id=${layout?.layout_type_id}&num_screens.list=${
    layout.screens.length
  }${orientation ? '&orientation=' + orientation : ''}${
    selectedLocationGroupId ? `&id.notlist=${selectedLocationGroupId}` : ''
  }&daypart_id=${daypartId}&default_assemblies=true`;
};

export const mergeLocationGroupList = (
  savedDate?: ILocationGroupTabList[],
  newData?: ILocationGroupTabList[],
) => {
  const merged = [...(savedDate ?? []), ...(newData ?? [])];

  return merged.reduce(
    (acc: ILocationGroupTabList[], item: ILocationGroupTabList) => {
      if (!acc.find((i: ILocationGroupTabList) => i.id === item.id)) {
        acc.push(item);
      }

      return acc;
    },
    [],
  );
};
